// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"53":"3e984687","168":"26aec751","247":"b33dda20","257":"4fc72a06","331":"c4ccc11d","366":"96c2af8b","615":"a1da3ab0","767":"3f3fd019","818":"0f720c73","900":"7c874128","960":"ce257b57"}[chunkId] + ".chunk.js";
};